(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["guest-login"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('.guest-login');
    if (!root) return;

    const storageKey = 'guestLoginB2bError';
    const errorEl = root.querySelector('.guest-login__error');
    const shouldLogout = root.dataset.shouldLogout === 'true';
    const logoutUrl = root.dataset.logoutUrl;

    if (shouldLogout && logoutUrl) {
      try {
        sessionStorage.setItem(storageKey, '1');
      } catch (error) {}
      window.location.assign(logoutUrl);
      return;
    }

    try {
      if (sessionStorage.getItem(storageKey) === '1') {
        sessionStorage.removeItem(storageKey);
        if (errorEl) errorEl.hidden = false;
      }
    } catch (error) {}
  })();
  } catch(e) { console.error(e); }
})();

})();
